import { useMemo } from 'react';

export const randomId = (): string => {
  return (
    Math.random()
      .toString(36)
      .substring(2, 15) +
    Math.random()
      .toString(36)
      .substring(2, 15)
  );
};

export const useUniqueId = () => {
  const uniqueId = useMemo(() => randomId(), []);

  return {
    uniqueId,
  };
};
